import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { MaterialModule } from 'src/app/shared/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { DetalhamentoImportacao } from 'src/models/interfaces/importação/detalhamento-importacao-interface';

@Component({
  selector: 'spe-csv-step-result',
  templateUrl: './step-result.component.html',
  styleUrls: ['./step-result.component.scss'],
  imports: [MaterialModule, SharedModule]
})
export class StepResultComponent {
  @Input() alertTitle: string = '';
  @Input() alertMessage: string = '';
  @Input() detalhamento: DetalhamentoImportacao | null = null;

  @Output() eventImportResume = new EventEmitter<void>();
  @Output() eventNewImport = new EventEmitter<void>();
  @Output() eventDetalhamento = new EventEmitter<void>();

  constructor(public commonService: CommonService) {}
}
